import React from 'react';
import { DefaultButton, Spinner, SpinnerSize } from '@fluentui/react';
import { LifecycleGridItem } from './MyAccessRequests.types';

export interface MyAccessRequestsSelectionBarProps {
    selectedItems: LifecycleGridItem[];
    batchInProgress: boolean;
    onCancelSelected: () => void;
    onRemoveSelected: () => void;
    onClearSelection: () => void;
}

const MyAccessRequestsSelectionBar = ({
    selectedItems,
    batchInProgress,
    onCancelSelected,
    onRemoveSelected,
    onClearSelection,
}: MyAccessRequestsSelectionBarProps): JSX.Element | null => {
    const count = selectedItems.length;
    const allCanCancel = count > 0 && selectedItems.every(x => x.canCancel);
    const allCanRemove = count > 0 && selectedItems.every(x => x.canRemove);
    const isMixed = count > 0 && !allCanCancel && !allCanRemove;

    if (count === 0) return null;

    return (
        <div style={{
            padding: '8px 10px',
            borderTop: '2px solid #0078d4',
            background: '#f3f9fd',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 8,
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {count > 0 && (
                    <span style={{ fontSize: 14, fontWeight: 600, color: '#323130' }}>
                        {count} item{count > 1 ? 's' : ''} selected
                    </span>
                )}
                {isMixed && (
                    <span style={{ fontSize: 12, color: '#a80000' }}>
                        — select only cancel-eligible or remove-eligible rows
                    </span>
                )}
                {batchInProgress && (
                    <Spinner size={SpinnerSize.small} label="Processing..." labelPosition="right" />
                )}
            </div>

            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                {count > 0 && (
                    <>
                        <DefaultButton
                            text="Cancel Selected"
                            disabled={!allCanCancel || batchInProgress}
                            title={isMixed ? 'Selection contains mixed row types' : !allCanCancel ? 'No cancel-eligible rows selected' : undefined}
                            onClick={onCancelSelected}
                        />
                        <DefaultButton
                            text="Remove Selected"
                            disabled={!allCanRemove || batchInProgress}
                            title={isMixed ? 'Selection contains mixed row types' : !allCanRemove ? 'No remove-eligible rows selected' : undefined}
                            onClick={onRemoveSelected}
                        />
                        <DefaultButton
                            text="Clear"
                            disabled={batchInProgress}
                            onClick={onClearSelection}
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default MyAccessRequestsSelectionBar;

